module.exports = __webpack_public_path__ + "static/media/avatar-crv.4637fd0b.jpg";